import { create } from 'zustand'

type BootstrapLoadingStore = {
  active: Record<string, boolean>
  setLoading: (key: string, isActive: boolean) => void
}

export const useBootstrapLoadingStore = create<BootstrapLoadingStore>()(
  (set) => ({
    active: {},
    setLoading: (key, isActive) =>
      set((state) => ({ active: { ...state.active, [key]: isActive } })),
  }),
)
